export default __webpack_public_path__ + "static/media/1364.7d4dd933.png";